<div class="row justify-content-center align-content-center" [class.finished]="IsFinished">
    <div class="col-auto m-auto"  [matTooltip]="file.DocumentDescription"  >{{file.DocumentCode}}</div>
    <div class="col-auto m-auto"  >{{file.DocumentDate | date}}</div>
    <div class="col-1">
        <mat-icon [class.finished]="IsFinished" class="material-symbols-outlined" [color]="IsFinished ? undefined : 'primary'" matTooltip="Voir pdf" (click)="ViewDocument()">remove_red_eye</mat-icon>
    </div>
    <div class="col-1">
        <mat-icon [class.finished]="IsFinished" class="material-symbols-outlined" [color]="IsFinished ? undefined : 'primary'" matTooltip="Télécharger pdf" (click)="DownloadDocument()" >get_app</mat-icon>
    </div>
</div>
